import {Injectable} from "@angular/core";
import {ProductControllerService, ProductWithRelations} from "@aparraga/ahoracrypto-api-sdk/sdk";
import {Mutex} from "async-mutex";


@Injectable()
export class ProductService {

  protected products = {}

  constructor(protected productControllerService: ProductControllerService) {
  }

  public refreshProducts(): Promise<ProductWithRelations[]> {

    let promise: Promise<any> = new Promise((resolve, reject) => {

      const mutex = new Mutex();
      mutex
        .acquire()
        .then((release) => {
          //check if the products object is empty
          if (Object.keys(this.products).length === 0) {
            this.productControllerService.productControllerFindCryptocurrencies().subscribe(cryptocurrencies => {
                cryptocurrencies.forEach(cryptocurrency => {
                  this.products[cryptocurrency.id] = cryptocurrency
                })
                release();
                resolve(this.products);
              },
              error => {
                release();
                reject(error);
              });
          }
          else {
            release();
            resolve(this.products);
          }
        });

    });

    return promise;

  }

  public getProduct(id: string): Promise<ProductWithRelations> {

    let promise: Promise<ProductWithRelations> = new Promise(async (resolve, reject) => {

      let returnValue = null;
      //check if the products object is empty
      if (Object.keys(this.products).length === 0) {
        await this.refreshProducts();
      }
      if(!!this.products[id]) {
        returnValue = this.products[id];
      }

      resolve(returnValue);
    });

    return promise;

  }

  public getProducts(): any {
      return this.products;
  }


}
